module.exports = __webpack_public_path__ + "static/media/planet_r_top.d156b489.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/planet_r_top.jpg
// module id = 516
// module chunks = 0